// extracted by mini-css-extract-plugin
export default {"smaller":"XnkC7HdDgvG70QgdBRQr","flexStop":"BiWTYeq2R28Zu0T8P6Fb","padding":"ISUpybe28lx4GywFf0y2"};